export default function (props: any) {
	window.location.href = 'https://t.me/' + props.peerName;
	return null;
};
